import { Navigate, useParams } from 'react-router-dom';

export default function AnonymousChallengeLessonQuizResult() {
  const { lessonId, quizId, runId, challengeId } = useParams();
  const redirect = `/challenges/${challengeId}/lessons/${lessonId}/quizzes/${quizId}/runs/${runId}/result`;

  return <Navigate to={`/welcome?to=${redirect}`} replace />;
}
